module.exports = __webpack_public_path__ + "static/media/sixt.789ae758.svg";